import React from 'react'
import {useForm} from 'react-hook-form'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import {useAddTranslation} from 'Event/LanguageProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import Settings from 'Event/template/Townhall/Leaderboard/LeaderboardConfig/Settings'
import {Townhall, useTownhallUpdate} from 'Event/template/Townhall'

export default function LeaderboardConfig(props: ComponentConfigProps) {
  const {showing: isVisible, onClose} = props
  const {control, register, handleSubmit, formState, watch} = useForm()
  const updateTemplate = useTownhallUpdate()
  const addTranslation = useAddTranslation()

  const submit = (data: {
    title: string
    description: string
    backToDashboardText: string
    backToDashboardTextColor: string
    isVisible: boolean
    points_unit: Townhall['points_unit']
    rewardAlert: Townhall['rewardAlert']
  }) => {
    const rewardText = replaceAtPath(
      data,
      'rewardAlert.text',
      '{{reward_text}}',
    )

    const backToDashboardText = replaceAtPath(
      data,
      'backToDashboardText',
      '{{leaderboard_back_to_dashboard_text}}',
    )

    const {rewardAlert, points_unit, ...leaderboardData} = data

    const updated = {
      rewardAlert: {
        text: '{{reward_text}}',
        backgroundColor: rewardAlert?.backgroundColor,
        textColor: rewardAlert?.textColor,
      },
      points_unit: points_unit,
      leaderboard: {
        ...leaderboardData,
        title: '{{leaderboard_title}}',
        description: '{{leaderboard_description}}',
        backToDashboardText: '{{leaderboard_back_to_dashboard_text}}',
      },
      localization: addTranslation({
        reward_text: rewardText ?? '',
        leaderboard_title: leaderboardData.title ?? '',
        leaderboard_description: leaderboardData.description ?? '',
        leaderboard_back_to_dashboard_text: backToDashboardText ?? '',
        points_unit: points_unit,
      }),
    }

    updateTemplate(updated)

    props.onClose()
  }

  return (
    <ComponentConfig
      showing={isVisible}
      onClose={onClose}
      title="Leaderboard"
      onSubmit={handleSubmit(submit)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} register={register} watch={watch} />
      </SettingsPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
